/** 详情/编辑：组 spec 与推理 system 回填表单前的统一规范化 */
import type { MaasGroupSpec } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import { MaasInferenceSource } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import {
  convertMaasGroupResourceForForm,
  resolveInferenceSourceFromSystem,
  stripCatalogInferenceMetadataFromSystem,
} from '@/delivery-type-plugin/capabilities/maas-node-groups/payload';

/** 组 spec 转为表单可读格式（resource + 自定义镜像 URL） */
export function normalizeMaasGroupForNodeFields(group?: MaasGroupSpec, envmap?: Record<string, unknown>): MaasGroupSpec | undefined {
  if (!group) return group;
  const next = convertMaasGroupResourceForForm(group) || group;
  const system = next.system as Record<string, unknown> | undefined;
  if (!system) return next;

  if (resolveInferenceSourceFromSystem(system) === MaasInferenceSource.Custom) {
    next.system = stripCatalogInferenceMetadataFromSystem(system);
  }

  const currentSystem = (next.system || system) as Record<string, unknown>;
  const env = (currentSystem.env || []) as { name: string; value: string }[];
  const newEnv = env.filter((item) => {
    // 在envmap里不存在key，或者value和envmap里的value不同
    const commonKeys = Object.keys(envmap || {});
    const hasKey = !!commonKeys.find((key) => key === item.name);
    const valueEqual = envmap?.[item.name] === item.value;
    return !hasKey || !valueEqual;
  });
  next.system = { ...currentSystem, env: newEnv };
  return next;
}

/** 推理 system 字段回填表单 */
export function normalizeMaasInferenceSystemForForm(system?: Record<string, unknown>): Record<string, unknown> | undefined {
  if (!system) return system;
  if (resolveInferenceSourceFromSystem(system) !== MaasInferenceSource.Custom) return system;
  return stripCatalogInferenceMetadataFromSystem(system) ?? system;
}
